import customerInfo from "../../../controls/customerinfo";

 
 

export const explanations = {
    notInArea: 'Thanks for your interest in this product! Unfortunately, it\'s not available for purchase in your area. <br /><br />If you have any questions or need help choosing an alternative product, please feel free to give us a call at 1-800-461-8898 or live chat with us and we\'d be happy to help.',
    itemOutOfStock: 'We\'re sorry this item is currently out of stock. Our team is working to get it back in stock asap.'
};

export const types = {
    idCustomerInState: 'id-includes-state',
    skuCustomerInState: 'sku-includes-state',
    idCustomerNotInState: 'id-not-in-state'
};

export default function handleRestrictions(viewmodel, restrictions) {
    const stateMatchingRestrictions = restrictions
        .filter(restriction => {
            if (restriction.type === types.idCustomerInState || restriction.type === types.idCustomerNotInState) {
                return restriction.id.includes((viewmodel.id()));
            }

            if (restriction.type === types.skuCustomerInState) {
                return viewmodel.products().find(p => restriction.id.includes(p.id()));
            }

            return false;
        });


    waitForUserData(viewmodel).then(({ isSPEUser, location }) => {
        if (isSPEUser) {
            return;
        }

        _handlers.handleLocationRestrictions(location, stateMatchingRestrictions, viewmodel);
    });
}

function handleLocationRestrictions(location, restrictions, viewmodel) {
    const byId = restrictions.find(restriction => restriction.type === types.idCustomerInState && restriction.state.includes(location.state));

    if (byId) {
        _handlers.updateViewModel(viewmodel, false, byId.message);
        return;
    }

    const notById = restrictions.find(restriction => restriction.type === types.idCustomerNotInState && !restriction.state.includes(location.state));

    if (notById) {
        _handlers.updateViewModel(viewmodel, false, notById.message);
        return;
    }

    const bySku = restrictions.find(restriction => restriction.type === types.skuCustomerInState && restriction.state.includes(location.state));

    if (bySku) {
        const checkId = (id) => {
            if (bySku.id.includes(id)) {
                _handlers.updateViewModel(viewmodel, false, bySku.message);
            } else {
                _handlers.updateViewModel(viewmodel, true, undefined);
            }
        };

        checkId(viewmodel.selectedProductId());

        viewmodel.selectedProductId.subscribe(id => checkId(id));
        return;
    }
}

function waitForLocation(viewmodel) {
    if (viewmodel.userDetectedLocation()) {
        return Promise.resolve(viewmodel.userDetectedLocation());
    }

    return new Promise(res => {
        const subscription = viewmodel.userDetectedLocation.subscribe(() => {
            res(viewmodel.userDetectedLocation());
            subscription.dispose();
        });                   
    });
}

function waitForUserData(viewmodel) {
    return Promise.all([customerInfo.getCustomerInfo(), waitForLocation(viewmodel)]).then(([customerInfoResponse, userDetectedLocation]) => {
        return {
            isSPEUser: customerInfoResponse?.content?.isSpeUser,
            location: userDetectedLocation
        };
    });
}

function updateViewModel(viewmodel, shouldShow, message) {
    viewmodel.canShowOrderControl(shouldShow);
    viewmodel.orderControlHiddenExplanation(message);
}

export const _handlers = {
    updateViewModel,
    handleLocationRestrictions
};